<template>
  <div class="grid-container">
    <div class="grid-row">
      <div class="titulo-grid">
        Informações Circuito - SGP ID: {{ dadosFichaTecnica.pco_tarefa.pco_circuito_id }}
      </div>
    </div>

  <div class="grid-row" v-if="dadosFichaTecnica.pco_tarefa.pco_circuito">
    <div class="titulo">
      Código do Circuito
    </div>
    <div class="">
      <a :href="getLinkCircuito()" target="_blank">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.cod_cir }} /
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.ponta }}
      </a>
    </div>
    <div class="titulo">
      Terminal
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.terminal }}
    </div>
  </div>

  <div class="grid-row">
    <div class=" titulo">
      Data Cadastro tarefa
    </div>
    <div class="">
      {{ formataDataBr(dadosFichaTecnica.pco_tarefa.created_at) }}
    </div>
    <div class=" titulo">
      Data Fim tarefa
    </div>
    <div class="">
      <span v-if="dadosFichaTecnica.pco_tarefa.finalized_at">
        {{ formataDataBr(dadosFichaTecnica.pco_tarefa.finalized_at) }}
      </span>
      <span v-else>-</span>
    </div>
  </div>

  <div class="grid-row">
    <div class=" titulo">
      Tipo de Alteração
    </div>
    <div class="">
      <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_tipo_alteracao">
        {{ tipoAlteracao }}
      </span>
      <span v-else>-</span>
    </div>
    <div class=" titulo">
      Disponibilizado
    </div>
    <div class="">
      {{ ( dadosFichaTecnica.pco_tarefa.pco_circuito.star21_status && 
          (dadosFichaTecnica.pco_tarefa.pco_circuito.star21_status.status_disponibilizado == 1)) ? 'Sim' : 'Não'
      }}
    </div>
  </div>
  <div class="grid-row">
    <div class=" titulo">
      Designação
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.designacao.toUpperCase() }}
    </div>
    <div class=" titulo">
      Velocidade
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.velocidade.toUpperCase() }}
    </div>
  </div>

  <template v-if="podeVisualizarFichaCompleta">
    <div class="grid-row">
      <div class=" titulo">
        Pendência Star21
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_pendencia.label }}
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_pendencia.pendencia">
        ({{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_pendencia.pendencia }})
      </span>

      </div>
      <div class=" titulo">
        ctrl_star21_pendencia_anterior_id
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.ctrl_star21_pendencia_anterior_id }}
      </div>
    </div>
    <div class="grid-row">
      <div class=" titulo">
        Data de inicio da Pendência
      </div>
      <div class="">
      <span v-if="dadosFichaTecnica.pco_tarefa.data_inicio_pendencia">
        {{ dadosFichaTecnica.pco_tarefa.data_inicio_pendencia }}
      </span>
        <span v-else>-</span>

      </div>
      <div class=" titulo">
        Código Cir associado
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.cod_cir_associado">
          {{ dadosFichaTecnica.pco_tarefa.pco_circuito.cod_cir_associado }}
        </span>
          <span v-else>-</span>
      </div>
    </div>
    <div class="grid-row">
      <div class=" titulo">
        Dias Pendência (extração)
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.dias_pendencia }}
      </div>
      <div class=" titulo">
        Número Viabilidade
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.numero_viabilidade }}
      </div>
    </div>
  </template>
    <div class="grid-row">
      <div class=" titulo-grid">
        Serviço
      </div>
    </div>
    <div class="grid-row">
      <div class=" titulo">
        Serviço
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_servico">
          {{ (
            dadosFichaTecnica.pco_tarefa.pco_circuito.star21_servico.descricao ||
            dadosFichaTecnica.pco_tarefa.pco_circuito.star21_servico.servico)
            .toUpperCase() 
          }}
        </span>
        <span v-else>-</span>
      </div>
      <div class=" titulo">
        Portabilidade
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.portabilidade.toUpperCase() }}
      </div>
    </div>
    <div class="grid-row">
      <div class=" titulo">
        Modalidade
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_modalidade">
          {{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_modalidade.modalidade.toUpperCase() }}
        </span>
        <span v-else>-</span>
      </div>
      <div class=" titulo">
        Rede Híbrida
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.rede_hibrida }}
      </div>
    </div>

    <div class="grid-row">
      <div class=" titulo">
        BLC Wifi
      </div>
      <div class="">
        <span v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.blc_wifi">
          {{ dadosFichaTecnica.pco_tarefa.pco_circuito.blc_wifi.toUpperCase() }}
        </span>
        <span v-else>-</span>
      </div>
      <div class=" titulo">
        Operadora
      </div>
      <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.operadora }}
    </div>
    </div>

    <div class="grid-row">
      <div class=" titulo">
        Tipo Serviço
      </div>
      <div class="">
        <span>
          {{ tipoServico }}
        </span>
      </div>
      <div class=" titulo">
        Migração PABX Virtual
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.mig_pabx_virtual }}
      </div>
    </div>
    <div class="grid-row">
      <div class=" titulo">
        Valor Backlog
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.valor_backlog }}
      </div>
      <div class=" titulo">
        Origem Valor
      </div>
      <div class="">
        {{ dadosFichaTecnica.pco_tarefa.pco_circuito.origem_valor.toUpperCase() }}
      </div>
    </div>
  <div class="grid-row">
    <div class=" titulo">
      Classificação Gross
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.ctrl_classificacao_gross.classificacao || '-' }}
    </div>
    
    <div class="titulo">Redundante</div>
    <div class="" v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.star21_redundancia">{{ dadosFichaTecnica.pco_tarefa.pco_circuito.star21_redundancia.redundancia }}</div>
    <div v-else class="">-</div>
  </div>
  <div class="grid-row">
    <div class=" titulo">
      Broadsoft
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.broadsoft }}
    </div>

    <div class="">

    </div>
    <div class="">

    </div>
  </div>
 </div>  
</template>

<script>

import { formataDataBr } from '@/common/boot/Utils'

export default {
  name: "InformacoesCircuitoComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    },

    podeVisualizarFichaCompleta: {
      type: Boolean,
      required: true
    }
  },
  
  computed: {
    tipoAlteracao () {
      if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.star21_tipo_alteracao.descricao) {
        return this.dadosFichaTecnica.pco_tarefa.pco_circuito.star21_tipo_alteracao.descricao.toUpperCase();
      }
      return this.dadosFichaTecnica.pco_tarefa.pco_circuito.star21_tipo_alteracao.tipo_alteracao.toUpperCase();
    },
    tipoServico () {
      const tipo_servico = this.dadosFichaTecnica.pco_tarefa.pco_circuito.star21_tipo_servico
      if (tipo_servico) {
        if(tipo_servico.descricao) {
          return tipo_servico.descricao.toUpperCase()
        }
        return tipo_servico.tipo_servico.toUpperCase()
      }
      return "-"
    }
  },

  methods: {
    getLinkCircuito() {
      var link = '';

      if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.cod_cir) {
        link = this.dadosFichaTecnica.link_star21 + '/star21/circuitos/fraHeaderCircuito_alterado.asp?cod_cir='
        link += this.dadosFichaTecnica.pco_tarefa.pco_circuito.cod_cir
      }
      return link == '' ? '#' : link;
    },

    formataDataBr,
  }
}
</script>